export default __webpack_public_path__ + "static/media/presale.21a9b17a.svg";